@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="products()"
    [label]="'entity.products' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />
} @else {
  <elcia-dropdown
    [control]="control()"
    [items]="products()"
    [label]="'entity.product' | translate"
    [optionDisabled]="'disabled'"
    [textField]="'name'"
    [valueField]="'id'"
  />
}
